<div class="vertical-container-simple column-gap-1p25">
  <div class="flex-center-space-between">
    <span class="font-1 bold600">Balance sheet</span>
    <div *ngIf="!show.accounts && !show.emptyState" class="end-row-container row-gap-0p375">
      <div class="font-3 bold400 flex-center row-gap-0p375">
        <div>Compare last</div>
        <app-selector
          data-qa="bs-number-of-shown-periods-selector"
          [isNotInTable]="true"
          [outerClass]="'width-6'"
          [data]="periodsSelectors.numberSelector.data"
          [selectedItem]="periodsSelectors.numberSelector.selected"
          (itemEmitter)="updateNumberComparedBSPeriods($event)">
        </app-selector>
      </div>
      <app-selector
        data-qa="bs-period-type-selector"
        [isNotInTable]="true"
        [outerClass]="'width-7'"
        [data]="periodsSelectors.typeSelector.data"
        [selectedItem]="periodsSelectors.typeSelector.selected"
        (itemEmitter)="handleShownBSPeriodTypeChange($event)">
      </app-selector>
    </div>
  </div>

<!--        Balance Sheet Table            -->
<app-empty-state-standard
  *ngIf="show.emptyState"
  [isAdmin]="true"
  [heading]="'No allocated accounts yet.'"
  [buttonText]="'Go to assembly'"
  (buttonClick)="goToAssembly()"
>
</app-empty-state-standard>

<div *ngIf="!show.accounts" class="table-fms max-height-100pcnt">
  <table>
    <ng-container *ngIf="!show.emptyState">
      <colgroup>
        <col span="1" class="width-2pcnt" />
        <col span="1" class="width-26pcnt" />
        <col span="7" class="width-12pcnt" />
      </colgroup>
      <thead>
      <tr class="text-center">
        <th id="three-dots-menu">
          <app-three-dots-menu [matMenuTriggerFor]="menu"></app-three-dots-menu>
          <mat-menu class="mat-menu zero-padding" #menu="matMenu">
            <ul class="list">
              <app-drop-down-item
                data-qa="bs-pl-export-excel"
                class="width-100pcnt"
                [iconNameAndStyling]="'excel.svg'"
                [text]="'Export'"
                (click)="exportExcelBs()">
              </app-drop-down-item>
            </ul>
          </mat-menu>
        </th>
        <th class="size-xxl"></th>
        <ng-container *ngFor="let column of selectedBSDateColumns | keyvalue">
          <th class="size-m">
            <div>
              <app-input-date
                [attr.data-qa]="'bs-date-column' + column.key + '-input'"
                [minDate]="column.value.minDate"
                [maxDate]="column.value.maxDate"
                [(input)]="column.value.selectedDate"
                (inputChange)="changeBSDateColumn(column.key, $event)"
              >
              </app-input-date>
            </div>
          </th>
          <th class="size-m box left-right">Difference</th>
        </ng-container>
        <th class="size-m">
          {{ financialStatementPeriod }}
        </th>
      </tr>
      </thead>
    </ng-container>


    <tbody *ngFor="let part of parts; let i = index">
    <tr *ngIf="part.sums.quarterlySums.size" class="clickable" (click)="closePart(part.partName)">
      <td>
        <app-table-group-icon [opened]="show.parts[part.partName]"> </app-table-group-icon>
      </td>
      <td class="first-level-left-sticky body-header" colspan="2">
        <div class="start-row-container row-gap-0p625">
            <span class="light-bold">
              {{ part.partName }}
            </span>
        </div>
      </td>
      <td colspan="6"></td>
    </tr>
    <ng-container *ngIf="show.parts[part.partName]">
      <ng-container *ngFor="let item of part.financialStatementItems">
        <tr *ngIf="item.financialStatementAccounts.length && item.name !== accumulatedProfitAndLossItemName">
          <td></td>
          <td *ngVar="item.financialStatementAccounts.length as amountOfAccounts">
            <div class="start-row-container row-gap-1">
              <span class="centered-row-container row-gap-0p25" *ngIf="amountOfAccounts">
                <div
                  appShortenWithoutHover="30" [text]="item.name | uppercase">
                </div>
                <app-chain-icon
                  *ngIf="item.assetsAndLiabilities"
                ></app-chain-icon>
              </span>
              <app-button
                *ngIf="amountOfAccounts"
                class="hidden-button-until-hover no-background-button-wrapper"
                [size]="'xsmall'"
                (buttonClick)="showAllocatedAccounts(item)"
                data-qa="bs-item-show-allocated-accounts"
              >
                <div class="start-row-container row-gap-0p25 whitespace-nowrap">
                  <span> {{ amountOfAccounts }} account{{amountOfAccounts > 1 ? "s" : "" }} </span>
                  <app-all-icons [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
                </div>
              </app-button>
            </div>
          </td>
          <ng-container *ngFor="let column of selectedBSDateColumns | keyvalue">
            <td class="text-center">
              {{
                item.sums.dateColumnSums.get(column.value.selectedDate)
                  | switcherDashBraces : switcher : 0
              }}
            </td>
            <td class="text-center box left-right bg-black-1"
                *ngVar="calculateDateColumnsDifferences(column, item.sums) as diff"
                [ngClass]="{
                      'red-10': diff < 0,
                      'main-8': diff > 0
                  }">
              {{ diff | switcherDashBraces : switcher : 0 }}
            </td>
          </ng-container>
          <td class="text-center">
            {{ item.sums.balance | switcherDashBraces : switcher : 0 }}
          </td>
        </tr>
        <tr *ngIf="item.financialStatementAccounts.length && item.name === accumulatedProfitAndLossItemName">
          <td></td>
          <td *ngVar="item.financialStatementAccounts.length as amountOfAccounts">
            <div class="start-row-container row-gap-1">
              <span class="centered-row-container row-gap-0p25" *ngIf="amountOfAccounts">
                <div
                  appShortenWithoutHover="30" [text]="item.name | uppercase">
                </div>
                <app-chain-icon
                  *ngIf="item.assetsAndLiabilities"
                ></app-chain-icon>
              </span>
              <app-button
                *ngIf="amountOfAccounts"
                class="hidden-button-until-hover no-background-button-wrapper"
                [size]="'xsmall'"
                (buttonClick)="showAllocatedAccounts(item)"
                data-qa="bs-item-show-allocated-accounts"
              >
                <div class="start-row-container row-gap-0p25 whitespace-nowrap">
                  <span> {{ amountOfAccounts }} account{{amountOfAccounts > 1 ? "s" : "" }} </span>
                  <app-all-icons [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
                </div>
              </app-button>
            </div>
          </td>
          <ng-container *ngFor="let column of selectedBSDateColumns | keyvalue">
            <td class="text-center">
              {{
                item.sums.dateColumnSums.get(column.value.selectedDate)
                  | switcherDashBraces : switcher : 0
              }}
            </td>
            <td class="text-center box left-right bg-black-1"
                *ngVar="calculateDateColumnsDifferences(column, item.sums) as diff"
                [ngClass]="{
                      'red-10': diff < 0,
                      'main-8': diff > 0
                  }">
              {{ diff | switcherDashBraces : switcher : 0 }}
            </td>
          </ng-container>
          <td class="text-center">
            {{ item.sums.balance | switcherDashBraces : switcher : 0 }}
          </td>
        </tr>
      </ng-container>
    </ng-container>

    <tr *ngIf="part.sums.quarterlySums.size" class="light-bold total text-center">
      <td></td>
      <td class="text-left">Total {{ part.partName }}</td>
      <ng-container *ngFor="let column of selectedBSDateColumns | keyvalue">
        <td class="text-center">
          {{
            part.sums.dateColumnSums.get(column.value.selectedDate)
              | switcherDashBraces : switcher : 0
          }}
        </td>
        <td class="text-center box left-right bg-black-1"
            *ngVar="calculateDateColumnsDifferences(column, part.sums) as diff"
            [ngClass]="{
                      'red-10': diff < 0,
                      'main-8': diff > 0
                  }">
          {{ diff | switcherDashBraces : switcher : 0 }}
        </td>
      </ng-container>
      <td>
        {{ part.sums.balance | switcherDashBraces : switcher : 0 }}
      </td>
    </tr>
    </tbody>
    <tbody *ngIf="!show.emptyState">
    <tr class="text-center"
        [ngClass]="
          financialStatement.balanceSheetNetTotals.sumITP ||
          financialStatement.balanceSheetNetTotals.sumITPrevYear ||
          financialStatement.balanceSheetNetTotals.sumITYearBeforePrev
            ? 'bold700 bg-red-1 red-12'
            : 'bold700 bg-main-2 main-8'
        "
    >
      <td></td>
      <td class="text-left">Check:</td>
      <ng-container *ngFor="let column of selectedBSDateColumns | keyvalue">
        <td>
          {{
            financialStatement?.balanceSheetNetTotals?.dateColumnSums?.get(column.value.selectedDate)
              | switcherDashBraces : switcher : 0
          }}
        </td>
        <td class="text-center box left-right bg-black-1"
            *ngVar="calculateDateColumnsDifferences(column, financialStatement.balanceSheetNetTotals) as diff"
            [ngClass]="{
                      'red-10': diff < 0,
                      'main-8': diff > 0
                  }">
          {{ diff | switcherDashBraces : switcher : 0 }}
        </td>
      </ng-container>
      <td>
        {{
          financialStatement.balanceSheetNetTotals.balance
            | switcherDashBraces : switcher : 0
        }}
      </td>
    </tr>
    <tr
      class="bg-main-red-light"
      *ngIf="financialStatement.balanceSheetNetTotals.balance !== 0"
    >
      <td colspan="2"></td>
      <td colspan="7">
        <div
          class="br-0p75 padding-0p25-0p5 end-row-container row-gap-0p375 height-1p5"
        >
          <app-all-icons
            class="red-10"
            [iconNameAndStyling]="'exclamation.svg'"
          ></app-all-icons>
          <span class="font-4">
            <span class="bold600">{{TOTAL_CHECK_FAILED_TEXT.title}}</span> {{TOTAL_CHECK_FAILED_TEXT.description}}
          </span>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div *ngIf="show.accounts">
  <div class="table-header-button-and-title-wrapper row-gap-0p5 padding-1">
    <div class="start-row-container row-gap-0p5">
      <span
        data-qa="bs-tb-drilldown-exit"
        class="clickable navigation-link start-row-container row-gap-0p5"
        (click)="show.accounts = false; isDrillDownEmitter.emit(false)"
      >
        <span> Balance sheet </span>
        <app-all-icons
          [iconNameAndStyling]="'right-arrow.svg'">
        </app-all-icons>
      </span>
      <span
        *ngIf="trialBalanceComponent"
        data-qa="bs-drilldown-exit-gl-to-tb"
        [ngClass]="{'clickable navigation-link': trialBalanceComponent?.show.glDrilldown}"
        (click)="trialBalanceComponent.show.glDrilldown=false"
      >
        {{ selectedItemForDrilldown?.partName }} - {{ selectedItemForDrilldown?.name | uppercase }}
      </span>
      <ng-container *ngIf="trialBalanceComponent?.show.glDrilldown" >
        <app-all-icons
          [iconNameAndStyling]="'right-arrow.svg'">
        </app-all-icons>
        <span *ngVar="trialBalanceComponent.selectedAccountForDrilldown.glTransactions.length as transactionsAmount">
          {{ trialBalanceComponent.selectedAccountForDrilldown.code }} -
          {{ trialBalanceComponent.selectedAccountForDrilldown.name }} |
          {{ transactionsAmount }}
          {{ transactionsAmount === 1 ? 'entry' : 'entries' }}
        </span>
      </ng-container>
    </div>
    <div class="end-row-container row-gap-0p5">
      <span class="start-row-container row-gap-0p25">
        From:
        <app-input-date
          data-qa="item-drilldown-date-picker"
          #accountFilterForDataDatePicker
          [maxDate]="accountFilterDataForDrilldown.selectedPeriod"
          [isRequired]="true"
          [(input)]="accountFilterDataForDrilldown.selectedDate"
          (inputChange)="drilldownFilterChange(accountFilterDataForDrilldown.selectedPeriod, $event)"
        >
        </app-input-date>
      </span>
      <span class="start-row-container row-gap-0p25">
        Till:
        <app-selector
          data-qa="item-drilldown-period-selector"
          class="font-3 width-11 black-9"
          [data]="accountFilterDataForDrilldown.selectorPeriods"
          [selectedItem]="accountFilterDataForDrilldown.selectedPeriod"
          (itemEmitter)="drilldownFilterChange($event, accountFilterDataForDrilldown.selectedDate)">
        </app-selector>
      </span>
      <app-button
        data-qa="reset-button-account-drilldown-filter"
        [type]="'dark-grey'"
        [size]="'small'"
        (buttonClick)="resetAccountFiltersForDrilldown()"
      >
        Reset
      </app-button>
    </div>
  </div>

  <app-trial-balance
    #itemDrilldown
    class="green-scroll"
    [isDrilldown]="true"
    [isLocked]="financialStatement?.isCompleted || !isAdmin"
    [showTrialBalanceNavBar]="false"
    [tbData]="selectedItemForDrilldown.financialStatementAccounts"
    [accountFilterDataObject]="accountFilterDataForDrilldown"
    (manualAccountEmitter)="manualAccountEmitter.emit($event)"
    (bulkDeleteEmitter)="bulkDeleteAccountsEmitter.emit($event)"
  >
  </app-trial-balance>
</div>
</div>
